import React, { lazy } from 'react';

const Home = lazy( () => import( './routes/home/home.jsx' ) );
const About = lazy( () => import( './routes/about/about.jsx' ) );

export const routes = [
    {
        pattern: '/',
        component: Home,
        requireAuthentication: true,
        title: 'Home - Roster Groups Hatch'
    },
    {
        pattern: '/home',
        component: Home,
        requireAuthentication: true,
        title: 'Home - Roster Groups Hatch'
    },
    {
        pattern: '/about',
        component: About,
        requireAuthentication: true,
        title: 'About'
    }
];

const Bundle = ( Component ) => (
    ( props ) => (
        <Component { ...props } />
    )
);

export const getMiddleware = () => {
    return [
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            const { match } = nextRoute;

            if ( match && !match.render && typeof match.component !== 'undefined' ) {
                match.render = Bundle( match.component, match.props );
                action.ok();
            } else {
                action.ok();
            }
        }
    ];
};
